"use client";

import { Dropdown, Card, ButtonGroup, SplitButton, DropdownButton } from "react-bootstrap";

const DropDirections = () => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <h4 className="fs-18 mb-4">Drop Directions</h4>

          <div className="mb-2 d-flex gap-2 flex-wrap">
            {["up", "up-centered", "down", "down-centered", "start", "end"].map(
              (direction) => (
                <DropdownButton
                  as={ButtonGroup}
                  key={direction}
                  id={`dropdown-button-drop-${direction}`}
                  drop={direction}
                  variant="secondary"
                  title={` Drop ${direction} `}
                >
                  <Dropdown.Item eventKey="1">Action</Dropdown.Item>
                  <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
                  <Dropdown.Item eventKey="3">
                    Something else here
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item eventKey="4">Separated link</Dropdown.Item>
                </DropdownButton>
              )
            )}
          </div>

          <div className="d-flex gap-2 flex-wrap">
            {["up", "up-centered", "down", "down-centered", "start", "end"].map(
              (direction) => (
                <SplitButton
                  key={direction}
                  id={`dropdown-button-drop-${direction}`}
                  drop={direction}
                  variant="secondary"
                  title={`Drop ${direction}`}
                >
                  <Dropdown.Item eventKey="1">Action</Dropdown.Item>
                  <Dropdown.Item eventKey="2">Another action</Dropdown.Item>
                  <Dropdown.Item eventKey="3">
                    Something else here
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item eventKey="4">Separated link</Dropdown.Item>
                </SplitButton>
              )
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default DropDirections;
